export default __webpack_public_path__ + "static/supertokens-logo-backdrop-8ca4973318dd113281231dbf19ad85ea.png";